module.exports = __webpack_public_path__ + "static/media/verdanab.215accaa.ttf";